import { DataPage } from "@interfaces/data-page";
import spareParts from "./spare-parts.util";

export default function setupPages<T>(data: T[], rows: number) {
  const separatedItems: T[][] = spareParts(data, rows);

  const pages: DataPage<T>[] = [];

  separatedItems.forEach((data, index) => {
    pages.push({
      page: index + 1,
      data
    });
  });

  return pages;
}
